// extracted by mini-css-extract-plugin
export default {"base":"vp_H4xEQ","notLoaded":"vp_fOTZ2","notLoadedText":"vp_xHVXx","tag":"vp_VMPwo","sonar":"vp_bx4Kd","site-story-sonar":"vp_rKgyp","delayed":"vp_plnFb"};